import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";
import {FetchHandler} from "../../../../infrastructure/handlers/fetch-handler";
import type {NewSearchWidgetController} from "../../new-search-widget.controller";
import type {NewSearchWidgetState} from "../../models/new-search-widget.state";
import {AthletesDomainService} from "../../../../domain/athletes/services/athletes.domain-service";
import {AthletesRequestParams} from "../../../../domain/athletes/models/athletes.request-params";
import {AthleteViewModel} from "../../../../domain/common/athlete/athlete-view-model";
import {NewSearchWidgetListModel} from "../../models/new-search-widget.list.model";
import {COMPONENT_STATES} from "../../../../core/consts";

export class NewSearchWidgetTopAthletesFetchHandler extends FetchHandler {
  controller: NewSearchWidgetController;
  state: NewSearchWidgetState;
  type = NEW_SEARCH_WIDGET.ACTION_TYPES.TOP_ENTITIES.fetchAthletes;


  static injectables = [AthletesDomainService];

  onLoaded() {
    super.onLoaded();

    this.action();
  }

  get requestParams(): AthletesDomainService {
    const limit: Number = this.controller.device.isSmallView ? NEW_SEARCH_WIDGET.MAX_TOP_ENTITIES.mobile : NEW_SEARCH_WIDGET.MAX_TOP_ENTITIES.desktop;
    const requestParams: AthletesRequestParams = new AthletesRequestParams(true, null, limit);

    return requestParams;
  }

  async action() {
    const dataSource = await super.fetch();

    if(dataSource?.athletes?.length > 0) {
      const entities = dataSource.athletes?.map(athlete => new AthleteViewModel(athlete));
      this.state.updateAthletesListModel(new NewSearchWidgetListModel(NEW_SEARCH_WIDGET.LIST_ID.topAthletes ,entities, 'WEB_SEARCH_POPULAR_PLAYERS', this.controller.terms, this.controller.device.isSmallView, false, NEW_SEARCH_WIDGET.HIGHLIGHTED_LIST_INDEX.athletes));
    }
    this.store.setComponentState(COMPONENT_STATES.loaded);

  }
}
